import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  templateUrl: './error.layout.html',
  imports: [RouterOutlet]
})
export class ErrorLayoutComponent {}
